'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactstrap = require('reactstrap');

require('./CountButton.scss');

var _index = require('../icon/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CountButton = function (_React$Component) {
    (0, _inherits3.default)(CountButton, _React$Component);

    function CountButton() {
        (0, _classCallCheck3.default)(this, CountButton);
        return (0, _possibleConstructorReturn3.default)(this, (CountButton.__proto__ || (0, _getPrototypeOf2.default)(CountButton)).apply(this, arguments));
    }

    (0, _createClass3.default)(CountButton, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                component = _props.component,
                type = _props.type,
                count = _props.count,
                colorCount = _props.colorCount,
                colorContent = _props.colorContent,
                icon = _props.icon,
                children = _props.children,
                className = _props.className,
                colorTextCount = _props.colorTextCount,
                onClick = _props.onClick,
                other = (0, _objectWithoutProperties3.default)(_props, ['component', 'type', 'count', 'colorCount', 'colorContent', 'icon', 'children', 'className', 'colorTextCount', 'onClick']);


            var showIcon = type !== "circle" && icon;

            var child = _react2.default.createElement(
                'div',
                (0, _extends3.default)({ className: className ? className + " count-button " + type : "count-button " + type }, other),
                (showIcon || typeof count !== "undefined" && count !== null) && _react2.default.createElement(
                    'div',
                    { className: "count-button-count " + colorCount + " " + (colorTextCount && colorTextCount + "-text") },
                    showIcon && _react2.default.createElement(_index.Icon, { size: '3x', icon: icon }),
                    _react2.default.createElement(
                        'span',
                        { className: 'count-button-count-label' },
                        count
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: "count-button-content w-" + (showIcon ? "75 " : "100 ") + colorContent },
                    _react2.default.createElement(
                        'span',
                        { className: 'count-button-text' },
                        children
                    )
                )
            );

            return _react2.default.createElement(component, { onClick: onClick }, child);
        }
    }]);
    return CountButton;
}(_react2.default.Component);

CountButton.propTypes = {
    count: _react2.default.PropTypes.number,
    type: _react2.default.PropTypes.string,
    icon: _react2.default.PropTypes.string,
    colorCount: _react2.default.PropTypes.string,
    colorContent: _react2.default.PropTypes.string,
    colorTextCount: _react2.default.PropTypes.string
    // component:
};
CountButton.defaultProps = {
    type: "box",
    component: "A"
};
exports.default = CountButton;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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